import fetch from './fetch'

export default {
  getReportGeneralCounts (payload) {
    let request = fetch({
      url: `/report/general-counts`,
      method: 'get',
      payload
    })
    return request.call()
  },
  getReportPersonCountsByTime (payload) {
    let request = fetch({
      url: `/report/person-by-time`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getReportAssessmentCountsByTime (payload) {
    let request = fetch({
      url: `/report/assessment-by-time`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getReportLaborScreeningCountsByTime (payload) {
    const request = fetch({
      url: '/report/laborscreening-by-time',
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getReportAssessmentIndicatorsByPerson (payload) {
    let request = fetch({
      url: `/report/assessment/indicators`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getReportCseitIndicatorsByPerson (payload) {
    let request = fetch({
      url: `/report/cseit/indicators`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getReportCseitCountsByTime (payload) {
    let request = fetch({
      url: `/report/cseit-by-time`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getReportAssessmentIndicators (payload) {
    let request = fetch({
      url: `/report/assessment/indicators`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getReportPersonCountsByDemographic (payload) {
    let request = fetch({
      url: `/report/person-by-demographics`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getReportAssessmentsByLocationForMap (payload) {
    let request = fetch({
      url: `/report/geography/assessment-by-location`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getReportPersonDemographicsOverTime (payload) {
    let request = fetch({
      url: `/report/person-by-demographics-by-time`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getReportCseitCountsByDemographic (payload) {
    let request = fetch({
      url: `/report/cseit-by-demographics`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getReportLaborScreeningCountsByDemographic (payload) {
    const request = fetch({
      url: '/report/laborscreening-by-demographics',
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getReportAssessmentCountsByDemographic (payload) {
    let request = fetch({
      url: `/report/assessment-by-demographics`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getReportAssessmentDemographicsOverTime (payload) {
    let request = fetch({
      url: `/report/assessment-by-demographics-by-time`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getReportCseitDemographicsByTime (payload) {
    let request = fetch({
      url: `/report/cseit-by-demographics-by-time`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getReportLaborScreeningDemographicsByTime (payload) {
    const request = fetch({
      url: '/report/laborscreening-by-demographics-by-time',
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getReportCseitIndicators (payload) {
    let request = fetch({
      url: `/report/cseit/indicators`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getReportLaborScreeningIndicators (payload) {
    const request = fetch({
      url: '/report/laborscreening/indicators',
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getAllUsers (payload) {
    let request = fetch({
      url: `/report/all-users`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getAllOrgs (payload) {
    let request = fetch({
      url: `/report/all-orgs`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getGroups (payload) {
    let request = fetch({
      url: `/report/all-groups`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getAllLogs (payload) {
    let request = fetch({
      url: `/report/all-logs`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getAllScreenings (payload) {
    let request = fetch({
      url: `/report/all-screenings`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getScreeningsByOrg (payload) {
    let request = fetch({
      url: `/report/screenings-by-org`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getLaborScreeningsByOrg (payload) {
    const request = fetch({
      url: '/report/laborscreenings-by-org',
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  }
}



// WEBPACK FOOTER //
// ./src/api/reports.js